import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './CardsItem.styles';
import { MoreHorizontalIcon } from '@/components/UI/Icons/Icons';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { renderAdditionalInfo } from '@/components/Profile/Cards/CardsItem.helpers';
import { SavedCard } from '@/api/types/cards.types';
import { getSavedCardSystemLogo } from '@/features/Profile/sections/PaymentMethods/helpers/getSavedCardSystemLogo';

interface CardsItemProps {
  card: SavedCard;
  onMoreClick: (card: SavedCard) => void;
  dropdown?: React.ReactNode;
}

export const CardsItem: React.FC<CardsItemProps> = ({
  card,
  onMoreClick,
  dropdown,
}) => {
  const { t } = useTranslation();
  const systemLogo = getSavedCardSystemLogo(card.system);
  const isPrimary = card.isPrimary && !card.isExpired;
  const additionalInfo = renderAdditionalInfo(t, card);

  return (
    <S.CardItem>
      <S.CardMain>
        {card.iconUrl?.url ? (
          <S.CardLogo src={card.iconUrl.url} alt={card.system} />
        ) : (
          <IconBox
            $filename={systemLogo ? `${systemLogo}.png` : 'cards.png'}
            $width={35}
            $height={30}
            $iconWidth={30}
          />
        )}
        <S.Info>
          <S.Name $variant="1">{card.name}</S.Name>
          <S.CardDetails>
            <S.BankName $variant="1">{card.issuer}</S.BankName>
            {additionalInfo && (
              <S.AdditionalInfo $variant="1" $isGreen={isPrimary}>
                {additionalInfo}
              </S.AdditionalInfo>
            )}
          </S.CardDetails>
        </S.Info>
      </S.CardMain>
      <S.Actions>
        <S.MoreButton onClick={() => onMoreClick(card)}>
          <MoreHorizontalIcon />
        </S.MoreButton>
        {dropdown}
      </S.Actions>
    </S.CardItem>
  );
};
